import SectionLabel from "@/components/base/SectionLabel";
import { ourDXViewData } from "@/mocks/aboutData";

export default function OurDXViewSection() {
  return (
    <section id="our-dx-view" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <SectionLabel label={ourDXViewData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 mb-5">
            {ourDXViewData.heading}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {ourDXViewData.paragraph}
          </p>
        </div>

        <div className="reveal max-w-3xl mx-auto">
          {/* Connected vertical flow with numbers */}
          <div className="relative">
            {/* Vertical connector line */}
            <div className="absolute left-[26px] md:left-[30px] top-10 bottom-10 w-[2px] bg-gradient-to-b from-primary-300/40 via-accent-300/30 to-primary-300/40" />

            <div className="space-y-6 md:space-y-8">
              {ourDXViewData.points.map((point, idx) => (
                <div key={idx} className="relative pl-14 md:pl-16">
                  {/* Number badge on the line */}
                  <div className="absolute left-0 top-1 w-[54px] md:w-[62px] h-[54px] md:h-[62px] rounded-full bg-background-50 border-2 border-primary-200/60 flex items-center justify-center z-10">
                    <span className="font-heading text-base md:text-lg font-bold text-primary-500">
                      {point.num}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
                    <div className="flex items-center gap-3 mb-2 md:mb-3">
                      <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className={`${point.icon} text-sm text-accent-600`} />
                      </div>
                      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">
                        {point.title}
                      </h3>
                    </div>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom arrow indicating cycle */}
            <div className="flex justify-center mt-6 md:mt-8">
              <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
                <i className="ri-loop-left-line" />
                <span>導入して終わらず、改善を続ける循環</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}